module.exports = __webpack_public_path__ + "partylineManage/img/KioskDark.7f781355.png";